const TOKEN_KEY = 'om_admin_token'

export function getAdminToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function setAdminToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearAdminToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

export async function adminFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const token = getAdminToken()
  const headers = new Headers(init.headers)
  if (token) headers.set('Authorization', `Bearer ${token}`)
  const res = await fetch(path, { ...init, headers })
  if (res.status === 401) {
    clearAdminToken()
    if (typeof window !== 'undefined' && !window.location.pathname.endsWith('/admin')) {
      window.location.href = '/admin'
    }
  }
  return res
}

export interface AdminDownloadStats {
  totalDownloads: number
  uniqueIpCount: number
  downloadsByPlatform: Record<string, number>
  downloadsByVersion: Record<string, number>
  downloadsByDay: { date: string; count: number }[]
}

export async function fetchDownloadStats(days: number): Promise<AdminDownloadStats> {
  const res = await adminFetch(`/website-api/downloads/stats?days=${days}`)
  if (!res.ok) throw new Error(`Stats request failed: ${res.status}`)
  return res.json()
}
